import { useCallback, useMemo } from "react";

import { useProfileListByType, useProfileTypeList } from "../../../api/profile";
import { SelectOption } from "../../../common/components/form/Select";
import { isNodeDeveloper, isUserAdmin } from "../../../utils/role";
import { getProfileTypeOptionsByNode } from "../../../utils/userProfile";
import { generateTypeDisplayName, ProfileType } from "../ProfileManageMentView";
import { useSelector } from "../../../redux/hooks";
import { currentRolesSelector } from "../../../redux/slices/auth/selectors";

type useProfileTypeOptionsProps = {
    profileTypeOptions: SelectOption[];
};

const useProfileTypeOptions = (): useProfileTypeOptionsProps => {
    const { data: allTypes } = useProfileTypeList();
    const currentRoles = useSelector(currentRolesSelector);
    const getIsOptionDisabled = useCallback(
        (type: string): boolean => {
            if (isNodeDeveloper()) {
                if (
                    type === ProfileType.DEVELOPER
                ) {
                    return true;
                } else if (
                    type === ProfileType.HSBC &&
                    isUserAdmin(currentRoles)
                ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (
                    type === ProfileType.MAIN_CONTRACTOR
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        [currentRoles],
    );

    const profileTypeOptions: SelectOption[] = useMemo(() => {
        const allTypeOptions = allTypes?.map((type) => ({
            value: type,
            label: generateTypeDisplayName(type),
            isDisabled: getIsOptionDisabled(type),
        }));
        return allTypeOptions ?? getProfileTypeOptionsByNode(isNodeDeveloper());
    }, [allTypes, getIsOptionDisabled]);

    return {
        profileTypeOptions,
    };
};

export default useProfileTypeOptions;
